import {
  ReplenishmentRequestStateTypes,
  ReplenishmentRequestActionTypes,
} from "./ReplenishmentRequest.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: ReplenishmentRequestStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
  fetchRequestNumber: resetApiCallState(null),
};

const ReplenishmentRequestReducer = (
  state: ReplenishmentRequestStateTypes = INITIAL_STATE,
  action: any
): ReplenishmentRequestStateTypes => {
  switch (action.type) {
    case ReplenishmentRequestActionTypes.FETCH_ALL_REPLENISHMENT_REQUEST:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case ReplenishmentRequestActionTypes.FETCH_ALL_REPLENISHMENT_REQUEST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ReplenishmentRequestActionTypes.FETCH_ALL_REPLENISHMENT_REQUEST_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ReplenishmentRequestActionTypes.FETCH_ALL_REPLENISHMENT_REQUEST_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case ReplenishmentRequestActionTypes.FETCH_ONE_REPLENISHMENT_REQUEST:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case ReplenishmentRequestActionTypes.FETCH_ONE_REPLENISHMENT_REQUEST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ReplenishmentRequestActionTypes.FETCH_ONE_REPLENISHMENT_REQUEST_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ReplenishmentRequestActionTypes.FETCH_ONE_REPLENISHMENT_REQUEST_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    //----

    case ReplenishmentRequestActionTypes.FETCH_REPLENISHMENT_REQUEST_NUMBER:
      return {
        ...state,
        fetchRequestNumber: {
          error: null,
          payload: null,
          isPending: true,
          isSuccessful: false,
        },
      };
    case ReplenishmentRequestActionTypes.FETCH_REPLENISHMENT_REQUEST_NUMBER_RESET:
      return {
        ...state,
        fetchRequestNumber: resetApiCallState([]),
      };
    case ReplenishmentRequestActionTypes.FETCH_REPLENISHMENT_REQUEST_NUMBER_FAILURE:
      return {
        ...state,
        fetchRequestNumber: {
          payload: null,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ReplenishmentRequestActionTypes.FETCH_REPLENISHMENT_REQUEST_NUMBER_SUCCESS:
      return {
        ...state,
        fetchRequestNumber: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default ReplenishmentRequestReducer;
